import styled from 'styled-components';

const UserBox = styled.div`
  color: white;
  padding: 20px 28px;
`;

export default UserBox;
